const VIEWPORT_ACTIONS = {
  TOGGLE_MAIN_MENU: 'TOGGLE_MAIN_MENU',
};

export default VIEWPORT_ACTIONS;

const BUTTON_TYPES = {
  CLOSE: 'CLOSE',
  CANCEL: 'CANCEL',
};

export {BUTTON_TYPES};
